/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Allow_List_SubtitleInputs */

const en_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let Deep Focus work without blocking every app.`)
};

const ar_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دع ميزة التركيز العميق تعمل دون حظر كل تطبيق.`)
};

const de_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lassen Sie Deep Focus arbeiten, ohne jede Anwendung zu blockieren.`)
};

const es_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja que la concentración profunda funcione sin bloquear todas las apps.`)
};

const fr_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez Concentration Profonde fonctionner sans bloquer toutes les applications.`)
};

const it_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia che Concentrazione Intensiva funzioni senza bloccare tutte le app.`)
};

const ja_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「ディープフォーカス」中でも、すべてのアプリをブロックせずに作業できます。`)
};

const ko_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필요한 앱은 허용하면서 딥 포커스를 사용할 수 있어요.`)
};

const pt_br_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe que o Foco Total trabalhe sem bloquear todos os aplicativos.`)
};

const ru_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешите Глубокой фокусировке работать, не блокируя каждое приложение.`)
};

const th_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปล่อยให้การโฟกัสเต็มที่ทำงานได้ โดยไม่ต้องบล็อกทุกแอป`)
};

const tr_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derin Odaklanmanın her uygulamayı engellemeden çalışmasına izin ver.`)
};

const zh_cn_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让深度专注不再只能屏蔽所有软件`)
};

const zh_tw_daily_paywall_allow_list_subtitle = /** @type {(inputs: Daily_Paywall_Allow_List_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`讓深度專注不再只能封鎖所有 App`)
};

/**
* | output |
* | --- |
* | "Let Deep Focus work without blocking every app." |
*
* @param {Daily_Paywall_Allow_List_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_allow_list_subtitle = /** @type {((inputs?: Daily_Paywall_Allow_List_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Allow_List_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "ar") return ar_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "de") return de_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "es") return es_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "fr") return fr_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "it") return it_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "ja") return ja_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "ko") return ko_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "ru") return ru_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "th") return th_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "tr") return tr_daily_paywall_allow_list_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_allow_list_subtitle(inputs)
	return zh_tw_daily_paywall_allow_list_subtitle(inputs)
});